import { useTranslation } from "react-i18next";

export function ComingSoonHint({
  descriptionKey,
}: {
  descriptionKey?: string;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="grid max-w-xl gap-1" data-testid="settings-coming-soon">
      <p className="m-0 text-[0.8125rem] font-medium text-foreground">
        {t("settings.comingSoon")}
      </p>
      {descriptionKey ? (
        <p className="m-0 text-[0.75rem] leading-5 text-muted">{t(descriptionKey)}</p>
      ) : null}
    </div>
  );
}
